import React  from 'react';



export default function Enviocorreo() {



    

   

    return(
        <body>
            <div className="container">
                <div className="row justify-content-center">
                <form className="contact-form" >
                    <div>
                        <label htmlFor="email">Email:</label>
                        <input
                            type="email"
                            name="email"
                            
                            className="form-control"
                           />

                    </div>
                    <div>
                        <label htmlFor="asunto">Asunto:</label>
                        <input
                            type="text"
                            name="asunto"
                       
                            className="form-control"
                           />
                            
                    </div>
                    <div>
                        <label htmlFor="mensaje">mensaje:</label>
                        <textarea
                            rows="3"
                            name="mensaje"
                      
                            className="form-control"
                           
                            />
                    </div>
                    <div>
                        <br />
                        <button 
                            type="submit"
                            onSubmit={'Hola'}
                            > Enviar email                           
                            </button>

                    </div>
               
                    </form>
        </div>
        </div>
        </body>
       
    );

}